"use client";

import dynamic from "next/dynamic";
import { useState } from "react";

const SystemFaqModal = dynamic(
  () => import("@/components/SystemFaqModal").then((mod) => mod.SystemFaqModal),
  { ssr: false },
);

type Props = {
  className?: string;
  label?: string;
};

export function SystemFaqButton({ className = "btn-secondary", label = "FAQ" }: Props) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button type="button" onClick={() => setOpen(true)} className={className}>
        {label}
      </button>
      <SystemFaqModal open={open} onClose={() => setOpen(false)} />
    </>
  );
}
